import type { BankIdMode, PostRequest } from "../types";

export const bankIdTokenQuery = (
	mode: BankIdMode,
	tenant: string,
	ssn?: string | null,
): PostRequest => ({
	url: "/auth/start",
	method: "POST",
	body: {
		bankIdNumber: ssn,
		provider: "eid",
		mode: mode,
		tenant,
	},
});

export const authStatusQuery = (bankIdToken: string | null): PostRequest => ({
	url: "/auth/status",
	method: "POST",
	body: { bankIdToken, provider: "eid" },
});

export const cancelAuthQuery = (bankIdToken: string | null): PostRequest => ({
	url: "/auth/cancel",
	method: "POST",
	body: { bankIdToken, provider: "eid" },
});

export const verifyAuthQuery = (bankIdToken: string | null): PostRequest => ({
	url: "/auth/verify",
	method: "POST",
	body: { bankIdToken, provider: "eid" },
});

export const refreshAuthQuery = (refreshToken: string): PostRequest => ({
	url: "/auth/refresh",
	method: "POST",
	body: { refreshToken, provider: "eid" },
});
